import React, { useEffect } from 'react';

import { Checkbox } from 'antd';
import styled from 'styled-components';

import { VIEW_CATEGORY } from 'components/View/constants';
import { canViewPricingData } from 'helpers/permissions';

import { useAppSelector } from '../../../../store/hook';
import { useShareViaEmailContext } from '../ShareViaEmailContext';

const Sidebar = styled.div`
  width: 219px;
  min-height: 550px;
  padding-top: 32px;
  border-right: solid 1px var(--line-gray);
  font-size: 12px;
  padding-left: 30px;
  background-color: var(--background-gray-light);
`;

const Title = styled.h3`
  font-size: 16px;
`;

const Paragraph = styled.p`
  margin-bottom: 1px;
  font-size: 12px;
  color: ${(props) => props.color || 'var(--gray-dark)'};
  margin-top: ${(props: any) => props['margin-top'] || ''};
`;

const ViewsList = styled.div`
  display: flex;
  flex-direction: column;
  height: 395px;
  overflow: auto;
`;

interface Competitor {
  id: number;
  comunity_name: string;
}

interface Props {
  competitors: Competitor[];
}

const ShareViaEmailSidebar = ({ competitors }: Props) => {
  const { views } = useAppSelector((state) => state.global);
  const { currentUser } = useAppSelector((state) => state.auth);
  const { shareTabData, updateShareTabData } = useShareViaEmailContext();
  const showPricingData = canViewPricingData(currentUser);

  const viewsSelection = shareTabData.views ?? [];
  const hasCompetitors = Boolean(competitors?.length);
  const visibleViews = showPricingData
    ? views
    : views.filter(
        (item) => item.category !== VIEW_CATEGORY.CMA_SUMMARY && item.category !== VIEW_CATEGORY.SALES_BATTLECARD
      );

  useEffect(() => {
    const visibleViewIds = new Set(visibleViews.map((view) => view.id));
    const filteredSelection = viewsSelection.filter((id) => visibleViewIds.has(id));

    if (filteredSelection.length !== viewsSelection.length) {
      updateShareTabData({ views: filteredSelection });
    }
  }, [visibleViews, viewsSelection, updateShareTabData]);

  const handleViewSelection = (selected: number[]) => {
    updateShareTabData({ views: selected });
  };

  return (
    <Sidebar>
      <Title>Filters</Title>
      <Paragraph margin-top="15px">Competitors</Paragraph>
      {!hasCompetitors && <Paragraph color="var(--negative-orange)">No Competitors</Paragraph>}
      {(competitors ?? []).map((comp) => (
        <Paragraph key={comp.id} color="#222">
          {comp.comunity_name}
        </Paragraph>
      ))}
      <Paragraph margin-top="20px">Views</Paragraph>
      <Checkbox.Group value={viewsSelection} onChange={handleViewSelection}>
        <ViewsList className="mini-scroll">
          {visibleViews.map((item) => (
            <Checkbox key={item.id} value={item.id}>
              {item.name}
            </Checkbox>
          ))}
        </ViewsList>
      </Checkbox.Group>
    </Sidebar>
  );
};

export default ShareViaEmailSidebar;
